export default __webpack_public_path__ + "static/media/thunderstom_rain.95de49b4.svg";